import { useMemo } from 'react';
import { useRecoilValue } from 'recoil';
import { DoseMatrix } from '~/domain/patient/doseMatrix';
import { Image3D } from '~/domain/patient/image3d';
import { RigidRegistration } from '~/domain/patient/rigidRegistration';
import { StructureSet } from '~/domain/patient/structureset';
import { currentDoseState } from '~/state/atoms/dose/doseAtoms';
import {
    blendImageState,
    primaryImageState,
    selectedRegistrationState,
} from '~/state/atoms/image/imageAtoms';
import { currentStructureSetState } from '~/state/atoms/structureSet/structureSetAtoms';

export type ActiveItem = Image3D | DoseMatrix | StructureSet | RigidRegistration;

export default function useActiveItems(): ActiveItem[] {
    const selectedPrimaryImage = useRecoilValue(primaryImageState);
    const selectedBlendedImage = useRecoilValue(blendImageState);
    const selectedStructureSet = useRecoilValue(currentStructureSetState);
    const selectedDose = useRecoilValue(currentDoseState);
    const selectedRegistration = useRecoilValue(selectedRegistrationState);

    return useMemo(
        () =>
            [
                selectedPrimaryImage,
                selectedBlendedImage,
                selectedStructureSet,
                selectedDose,
                selectedRegistration,
            ].filter((item) => !!item) as ActiveItem[],
        [
            selectedPrimaryImage,
            selectedBlendedImage,
            selectedStructureSet,
            selectedDose,
            selectedRegistration,
        ]
    );
}